"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CELL_CATEGORY_KEY = 'base';
exports.CELL_PARENT_COMPONENT_KEY = 'table';
exports.CELL_COMPONENT_KEY = 'cell';